// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8f5d4cc2cf8a52346482a63d14464914400af6db.chunk.js";
};